import React, { useMemo } from 'react';
import { Menu } from 'antd';
import { Link, NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CryptoLogo, FinanceLogo, HomeLogo, Logout, MonestoLogoShort, UnifyLogo } from 'IMAGE';
import { useSelector } from 'react-redux';
import merge from 'deepmerge';
import '../../../styles/partials/_sidebarProject.less';

const SidebarProject = ({
  basePath,
  isMagmaTokenAvailable,
  isFinariumTokenAvailable,
  isUnifyTokenAvailable,
  isMonestoTokenAvailable,
}) => {
  const location = useLocation();

  // Получаем ids пользователя и проверяем, является ли он специальным
  const userIds = useSelector((state) => state.personal.customers_ids);
  const isDoubleAccountMagmaMonesto = useSelector((state) => state.personal.doubleAccountMagmaMonesto);
  const configs = merge(require('ROOT/configs.json'), require('ROOT/configs.prod.json'), {
    arrayMerge: (target, source) => [...new Set([...target, ...source])],
  });
  const specialUsers = configs.variables.magma_and_monesto_users;
  const isSpecialUser = specialUsers?.some((item) => userIds.includes(item)) || isDoubleAccountMagmaMonesto;

  const selectedKey = useMemo(() => {
    const path = location.pathname;
    if (path.includes('/finance')) return 'finance';
    if (path.includes('/home')) return 'home';
    if (path.includes('/crypto')) return 'crypto';
    if (path.includes('/investment')) return 'investment';
    if (path.includes('/monesto')) return 'monesto';
    return 'home';
  }, [location.pathname]);

  // Функция для определения нужно ли показывать FINANCE (MAGMA)
  const shouldShowFinance = () => {
    if (!isMagmaTokenAvailable) return false;

    if (isSpecialUser) {
      // Для специальных пользователей: показываем MAGMA всегда, если есть токен
      return true;
    } else {
      // Для обычных пользователей: показываем MAGMA только если нет MONESTO токена
      return !isMonestoTokenAvailable;
    }
  };

  // Функция для определения нужно ли показывать MONESTO
  const shouldShowMonesto = () => {
    if (!isMonestoTokenAvailable) return false;

    if (isSpecialUser) {
      // Для специальных пользователей: показываем MONESTO если есть токен
      return true;
    } else {
      // Для обычных пользователей: показываем MONESTO если есть токен
      // (MONESTO показывается всегда, когда есть токен, но в UI он будет отдельно)
      return true;
    }
  };

  console.log('SidebarProject - isSpecialUser:', isSpecialUser);
  console.log('SidebarProject - shouldShowFinance:', shouldShowFinance());
  console.log('SidebarProject - shouldShowMonesto:', shouldShowMonesto());
  console.log('SidebarProject - isMagmaTokenAvailable:', isMagmaTokenAvailable);
  console.log('SidebarProject - isMonestoTokenAvailable:', isMonestoTokenAvailable);

  return (
    <div className='sidebar-project'>
      <Menu className='nav-bar' selectedKeys={[selectedKey]}>
        <Menu.Item className='item-link' key='home'>
          <Link to={`${basePath}/home`}>
            <div className='item-link__logo'>
              <HomeLogo />
            </div>
            <span className='item-link__text'>HOME</span>
          </Link>
        </Menu.Item>

        {/* FINANCE (MAGMA) - показываем по условию */}
        {shouldShowFinance() && (
          <Menu.Item className='item-link' key='finance'>
            <Link to={`${basePath}/finance`}>
              <div className='item-link__logo'>
                <FinanceLogo />
              </div>
              <span className='item-link__text'>FINANCE</span>
            </Link>
          </Menu.Item>
        )}

        {/* CRYPTO (FINARIUM) - показываем всем, если есть токен */}
        {isFinariumTokenAvailable && (
          <Menu.Item className='item-link' key='crypto'>
            <Link to={`${basePath}/crypto`}>
              <div className='item-link__logo'>
                <CryptoLogo />
              </div>
              <span className='item-link__text'>CRYPTO</span>
            </Link>
          </Menu.Item>
        )}

        {/* INVESTMENT (LAVA/UNIFY) - показываем всем, если есть токен */}
        {isUnifyTokenAvailable && (
          <Menu.Item className='item-link' key='investment'>
            <Link to={`${basePath}/investment`}>
              <div className='item-link__logo'>
                <UnifyLogo />
              </div>
              <span className='item-link__text'>INVESTMENT</span>
            </Link>
          </Menu.Item>
        )}

        {/* MONESTO - показываем по условию */}
        {shouldShowMonesto() && (
          <Menu.Item className='item-link' key='monesto'>
            <Link to={`${basePath}/monesto`}>
              <div className='item-link__logo'>
                <MonestoLogoShort />
              </div>
              <span className='item-link__text'>MONESTO</span>
            </Link>
          </Menu.Item>
        )}
      </Menu>

      <NavLink to={'/company/logout'} className='logout'>
        <Logout />
        LOGOUT
      </NavLink>
    </div>
  );
};

SidebarProject.propTypes = {
  basePath: PropTypes.string.isRequired,
  isMagmaTokenAvailable: PropTypes.bool.isRequired,
  isFinariumTokenAvailable: PropTypes.bool.isRequired,
  isUnifyTokenAvailable: PropTypes.bool.isRequired,
  isMonestoTokenAvailable: PropTypes.bool.isRequired,
};

export default SidebarProject;
